import axios from 'axios'

const state = {
	userToken: '',
	initSearch:'',
	isLogged:false,
	connectUserID:'',
	connectUserEmail: ''
}
const mutations = {
	
	IS_LOGGED (state, payload) {
		state.isLogged = true;
	},
	SET_TOKEN_URL (state, payload) {
		state.userToken = payload;
	},
	SET_SEARCH_URL (state, payload) {
		state.initSearch = payload;
	},
	SET_CONNECT_USER_ID (state, payload) {
		state.connectUserID = payload;
	},
	SET_CONNECT_USER_EMAIL (state, payload) {
		state.connectUserEmail = payload;
	}
}

const actions = {
	setTokenURL({commit}, payload){
		commit('SET_TOKEN_URL',payload.tokenURL)
	},
	setInitSearch({commit}, payload){
		commit('SET_SEARCH_URL',payload.initSearch)
	},
	requireAuth ({ commit }, payload) {
		axios.defaults.headers.common['Authorization'] = 'Bearer '+this.getters.userToken
		axios.get(process.env.VUE_APP_URL_SSO_API +'user/me').then((response) => {
			commit('IS_LOGGED')
			commit('SET_CONNECT_USER_ID',response.data.id)
			commit('SET_CONNECT_USER_EMAIL',response.data.email)
			window.location='/admin'
		}).catch(error => {
			window.location = process.env.VUE_APP_URL_SSO_FRONT
		});
	}
}

const getters = {
	userToken: state => state.userToken,
	isLogged: state => state.isLogged,
	currentUserEmail: state => state.connectUserEmail
}

const authentificationModule = {
	state,
	mutations,
	actions,
	getters
}


export default authentificationModule;
